/**
 * A one-line bridge between the Notifications page and the header bell.
 *
 * Both read the server's notifications, but they are mounted in different
 * parts of the tree. When the page marks something read the badge has to
 * follow immediately, otherwise the count sits there stale until the next
 * navigation — which is exactly the mismatch this page used to have.
 */
const EVENT = 'nhc:patient-notifications-changed';

/** Tell every listener the server's notifications changed. */
export function notifyNotificationsChanged(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(EVENT));
}

/** Subscribe; returns the unsubscribe function. */
export function onNotificationsChanged(handler: () => void): () => void {
  if (typeof window === 'undefined') return () => {};
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
}
